// frontend_react/src/pages/kitchen/BarScreen.jsx

import React, { useEffect, useState } from "react";
import { getSocket, joinRoom } from "../../services/socket";
import { useAdminScope } from "../../context/AdminScopeContext";

function BarScreen() {
  const [tickets, setTickets] = useState([]);
  const { selectedCompanyUuid } = useAdminScope();

  useEffect(() => {
    setTickets([]);

    if (!selectedCompanyUuid) return;

    const socket = getSocket();
    const room = `bar:${selectedCompanyUuid}`;

    joinRoom(room);

    const onNewTicket = (data) => {
      if (data.destination !== "bar") return;
      if (data.company_uuid && data.company_uuid !== selectedCompanyUuid) return;

      try {
        new Audio("/ding-bar.mp3").play();
      } catch {
        console.warn("Audio blocked");
      }

      setTickets((prev) => [
        {
          ...data,
          status: "pending",
          createdAt: Date.now(),
        },
        ...prev,
      ]);
    };

    socket.on("bar:new_ticket", onNewTicket);

    return () => {
      socket.off("bar:new_ticket", onNewTicket);
    };
  }, [selectedCompanyUuid]);

  const updateStatus = (uuid, newStatus) => {
    setTickets((prev) =>
      prev.map((t) => (t.uuid === uuid ? { ...t, status: newStatus } : t))
    );
  };

  const columns = {
    pending: tickets.filter((t) => t.status === "pending"),
    preparing: tickets.filter((t) => t.status === "preparing"),
    ready: tickets.filter((t) => t.status === "ready"),
  };

  return (
    <div style={{ background: "#0b1a1f", minHeight: "100vh", color: "white", padding: 20 }}>
      <h1>🍹 Bar Live</h1>

      <div style={{ display: "flex", gap: 20 }}>
        <Column title="🟡 À préparer" tickets={columns.pending}>
          {(ticket) => (
            <button onClick={() => updateStatus(ticket.uuid, "preparing")}>
              ▶️ Préparer
            </button>
          )}
        </Column>

        <Column title="🔵 En cours" tickets={columns.preparing}>
          {(ticket) => (
            <button onClick={() => updateStatus(ticket.uuid, "ready")}>
              🍸 Servir
            </button>
          )}
        </Column>

        <Column title="🟢 Prêt" tickets={columns.ready}>
          {(ticket) => (
            <button onClick={() => updateStatus(ticket.uuid, "served")}>
              ✅ Terminé
            </button>
          )}
        </Column>
      </div>
    </div>
  );
}

function Column({ title, tickets, children }) {
  return (
    <div style={{ flex: 1 }}>
      <h2>{title}</h2>

      {tickets.map((ticket) => (
        <div
          key={ticket.uuid}
          style={{
            background: "#132a30",
            padding: 15,
            borderRadius: 10,
            marginBottom: 15,
          }}
        >
          <h3>Table {ticket.table_number}</h3>
          <p>#{ticket.ticket_number}</p>

          <ul>
            {(ticket.lines || []).map((line, idx) => (
              <li key={`${ticket.uuid}-${idx}`}>
                {line.quantity} × {line.name}
              </li>
            ))}
          </ul>

          <div style={{ marginTop: 10 }}>{children(ticket)}</div>
        </div>
      ))}
    </div>
  );
}

export default BarScreen;